import DashboardCount from "../../slices/dashboard/DashboardCount";
import CalendarMaintenance from "../../slices/dashboard/CalendarMaintenance";

const dashboardReducer = {
    dashboardCount: DashboardCount,
    calendarMaintenance: CalendarMaintenance,
};

export default dashboardReducer;